import React from 'react';
import { View } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const Overlay = () => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.overlay} />
	);
};

const createStyles = (theme) => ({
	overlay: {
		position: 'absolute',
		height: '100%',
		width: '100%',
		backgroundColor: theme.spinnerBg,
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 999,
	},
});

export default Overlay;
